import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'

const NotFoundPage = () => {
  return (
    <Container>
      <Row>
        <Col md={{ offset: 3 }} className="pl-4">
          <h3>404 - Not Found</h3>
        </Col>
      </Row>
    </Container>
  )
}

export default NotFoundPage